$(function(){
	$('.js-more:not(:first-of-type) .js-more-cnt').hide();
	$('.js-more:first-of-type .js-more-btn').addClass('ac');
	$('.js-more-btn').click(function(){
		var headerHeight = $('.l-header').outerHeight();
		var target = $(this).parents(".js-more");
		var position = (target.offset().top - headerHeight);	
		
		$(this).prev(".js-more-cnt").slideToggle();
		$(this).parent('.js-more').toggleClass("open");
		if($(this).hasClass('ac')){
			$('body,html').animate({scrollTop:position});
		}
		$(this).toggleClass("ac");
		return false;
		
	});
});

$(function () {
	$(".js-tab-list .js-tab-item").click(function () {
		$('.js-tab-box:not(.is-show)').css('display','none');
		const group = $(this).parents(".js-tab-blk");
		group.find(".is-active").removeClass("is-active");
		$(this).addClass("is-active");
		group.find(".is-show").removeClass("is-show");
		const index = $(this).index();
		group.find(".js-tab-box").eq(index).addClass("is-show").fadeIn("slow");
	});
});